import { Global, css } from "@emotion/react";

const GlobalStyle = () => (
  <Global
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        margin: 0;
        overflow: hidden;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: 4px;
        width: 28px;
        height: 28px;
      }
    `}
  />
);
export default GlobalStyle;
